
import { defineComponent, onMounted, reactive, toRefs ,getCurrentInstance, nextTick, onBeforeMount, watch} from 'vue'
import headSearch from '../common/mobileSearch.vue'
import MdEditor from 'md-editor-v3';
import 'md-editor-v3/lib/style.css';
import {useRoute,useRouter} from 'vue-router'
import { ElMessage } from 'element-plus' 
import tool from '@/utils/plugins/tools.js'
MdEditor.config({
    markedRenderer(renderer) {
      // 链接判断，如果是a跳新页签，如果是视频用video播放器
      renderer.link = (href, title, text) => {
          // 判断是视频还是链接
          if(text.indexOf('视频')>-1 ||(href&&(href.indexOf('.mp4')>-1||href.indexOf('video')>-1))){
          return `<video style="width: 350px"  autoplay loop muted name="media"><source src="${href}" type="video/mp4"><source src="${href}" type="video/ogg"></video>`
          }else{
            return `<a href="${href}" title="${title}" target="_blank">${text}</a>`;
          }
      };
      return renderer;
    }
});
export default defineComponent({
    components:{MdEditor,headSearch},
    setup() {
        const {proxy,appContext}= getCurrentInstance() as any
        const axios =appContext.config.globalProperties.axios
        const platformJson=appContext.config.globalProperties.platformJson
        const Cookies = appContext.app.config.globalProperties.Cookies
        const route = useRoute()
        const router = useRouter()
        const state:any=reactive({
            toolbars:[],
            lineTreeData:[],
            articleData:{
                docContent:'',
                updateTime:'',
                path:[],
                pre:'',
                post:'',
                preName:'',
                postName:''
            },
            mes:'',//文章
            showSuccessPart:false,
        })
        const methods=reactive({
            changeTreeId:(val:any)=>{
                // console.log(proxy.$refs.headPart.currentNode=val)
                proxy.$refs.headPart.currentNode=val
                router.push(`/marticle/${val}?bookId=${route.query.bookId}`)
                console.log(val,proxy.$refs.headPart.currentNode)
            },
            changeArticle:(v:any)=>{
                if(v=='pre'&&state.articleData.pre!='-1'){
                    methods.getArticleMes({id:state.articleData.pre})
                    methods.changeTreeId(state.articleData.pre)
                }else if(v=='next'&&state.articleData.post!='-1'){
                    methods.getArticleMes({id:state.articleData.post})
                    methods.changeTreeId(state.articleData.post)
                }
            },
            getArticleMes:(val:any)=>{
                let cookie:any=document.cookie
                let cookiesArray = cookie.split("; ");//拿到的所有cookie
                let cookieValue:any=''//拿到的成功社区cookie
                cookiesArray.map((item:any)=>{
                    if(item.includes('awssid=')){
                        cookieValue=item.split('=')[1]
                    }
                })
                axios.get(`/open/article/${val.id}?sid=${cookieValue}`,{}).then((res:any)=>{
                    let data=res.data
                    if(data.code==200){
                        state.showSuccessPart=false
                        let routePath=window.location.href.includes('#')?`${window.location.href.split('#')[0]+'#/article/'}`:'./marticle/'//判断路由情况
                        let extendMes:any='\n\n<cate>延伸阅读</cate>'
                        data?.data?.expandList?.map((item:any)=>{
                            extendMes=extendMes+`\n* [${item.docName}](${routePath+item.expandDocId}?bookId=${item.bookId})`
                        })
                        state.articleData={...data.data,path:JSON.parse(data.data.path),docContent:data.data.docContent.replaceAll('](./',`](${routePath}`)}
                        // 有扩展阅读加入到文章里面
                        if(data?.data?.expandList?.length>0){
                            state.articleData.docContent=state.articleData.docContent+extendMes
                        }
                        document.title=state.articleData.name+` - ${platformJson.name} - 帮助中心`;
                        // state.mes=data.data.docContent
                        // state.path=JSON.parse(data.data.path)
                        // state.updateTime=data.data.updateTime
                        // nextTick(()=>{
                        //     methods.formatterData()
                        // })
                        // (window as any)._hmt && (window as  any)._hmt.push(['_trackEvent', 'article','visit',data?.data?.name]);
                    // console.log(data,666)
                    }else if(data.code==700){
                        state.showSuccessPart=true
                        // window.location.href=data.data.successUrl+`?redirectUrl=${window.location.href.replaceAll('mhome','marticle')}/${val.id}?bookId=${route.query.bookId}`
                        window.location.href=data.data.successUrl+`?redirectUrl=${window.location.href}`
                        state.articleData.docContent=''
                        proxy.$message({
                            message: "该文章需登陆成功社区,请保存二维码微信扫码登录",
                            type: 'warning',
                            customClass:"customMessageBox"
                        })
                    }
                })
            },
            getLineTree:(list:any)=>{
                list.forEach((el:any) => {
                    state.lineTreeData.push({
                        id:el.id,
                        name:el.name,
                        pid:el.pid
                    })
                    if(el.children instanceof Array&&el.children.length>0){
                        methods.getLineTree(el.children)
                    }
                });
            },
            getTreeData:()=>{
                axios.get(`/open/tree/${route.query.bookId}`,{}).then((res:any)=>{
                    let data:any=res.data
                    if(data.code==200){
                        state.lineTreeData=[]
                        methods.getLineTree(data.data.list)
                        let path=route.path.split('/')
                        let routeId:any=path[path.length-1]
                        if(routeId){
                            proxy.$refs.headPart.currentNode=routeId
                            methods.getArticleMes({id:routeId})
                        }else if(state.lineTreeData.length>0){
                            proxy.$refs.headPart.currentNode=state.lineTreeData[0].id
                            methods.getArticleMes({id:state.lineTreeData[0].id})
                            router.push(`/marticle/${state.lineTreeData[0].id}?bookId=${route.query.bookId}`)
                        }
                        // nextTick(()=>{
                        //     proxy.$refs.treeRef.setCurrentKey(state.currentNode)
                        // })
                        // 看看有没有路由传过来的id，有就展示，没有就取树列第一个
                    }
                })
            },
            detailArticleStyle:()=>{
                // 给获取的图片父级添加样式
                let figureList:any=document.getElementsByClassName('figure')
                for(let i=0;i<figureList.length;i++){
                    if(figureList[i]&&figureList[i].parentNode){
                        let parentDom:any=figureList[i].parentNode
                        parentDom.style='display:flex;justify-content:flex-start'
                    }
                }
                // 给获取的video父级添加样式
                let videoList:any=document.getElementsByTagName('video')
                for(let i=0;i<videoList.length;i++){
                    if(videoList[i]&&videoList[i].parentNode){
                        let parentDom:any=videoList[i].parentNode
                        parentDom.style='display:flex;justify-content:center;overflow:hidden;'
                    }
                }
                //自定义块状，nav变色
                let blockquote:any=document.getElementsByTagName('blockquote')
                console.log(blockquote[0],'blockquote')
                for(let i=0;i<blockquote.length;i++){
                    if(blockquote[i].children&&blockquote[i].children.length>0){
                        for(let y=0;y<blockquote[i].children.length;y++){
                            if(blockquote[i].children[y].tagName=='NAV'){
                                // blockquote[i].style="background:#f5fcff;"
                                blockquote[i].style="border:none;background:#eef6ff;border-left:6px solid #8dc2ff ;"
                            }
                        }
                    }
                }
                setInterval(()=>{
                    let videoList:any=document.getElementsByTagName('video')
                    for(let i=0;i<videoList.length;i++){
                        if(videoList[i]&&videoList[i].parentNode){
                            let parentDom:any=videoList[i].parentNode
                            parentDom.style='display:flex;justify-content:center;overflow:hidden;'
                        }
                    }
                },1000)
            },
            saveHtml:()=>{
                setTimeout(() => {
                    methods.detailArticleStyle()
                }, 500);
            }
        })
        onBeforeMount(()=>{
            methods.getTreeData()
        })
        onMounted(()=>{
            document.addEventListener('DOMContentLoaded', (event) => {
                console.log('进来了')
                document.querySelectorAll('a').forEach((link) => {
                    link.addEventListener('click', function(event) {
                        debugger
                    // 阻止默认行为，例如跳转到href指定的URL
                    // event.preventDefault();
                    // 你的逻辑代码
                    window.location.reload()
                    });
                });
            });
            // 用于监听点击A标签时，不是地址链接的就定位到固定位置
            window.addEventListener('click',(event:any)=>{
                if(event.target.tagName=='A'){
                    if(event.target.outerHTML&&!event.target.outerHTML.includes('/article/')&&!event.target.outerHTML.includes('_blank')){
                        event.preventDefault()
                        let ids:any=event.target.outerHTML.split(`\"`)
                        let domId:any=ids[1]//切下想要的id
                        if(domId){
                            // 根据id获取dom，滚动到指定位置
                            (document.getElementById(domId.slice(1)) as any).scrollIntoView(true)
                        }
                    }
                }
            })
            tool.dataPiont({
                channelName:"AWS PaaS-帮助中心",
                behaviorNo:"0102",
                eventNo:tool.searchParam("_event")||tool.searchParam("utm_campaign"),
                browserId:Cookies.get("BROWSER_ID")||appContext.app.config.globalProperties.$fingerprint,
                url:window.location.href,
                title:document.title,
                utmsource:tool.searchParam("utm_source"),
                visitDate:tool.getCurrentFormattedTime(),
                device:tool.isMobile()?'mobile':'pc',
                mobile:'',
                visitType:'G'
            })
        })
        watch(()=>route.fullPath,()=>{
            window.location.reload()
        })
        return {
            ...toRefs(state),
            ...toRefs(methods)
        }
    },
})
